// Formatação de datas do chat interno (API envia ISO 8601 UTC).

/** "14:32" — hora curta para bolhas de mensagem. */
export const formatClock = (iso: string): string =>
  new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

const WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

/**
 * Rótulo curto da última mensagem na lista:
 * hoje → "14:32"; ontem → "Ontem"; últimos 7 dias → "Seg"; antes → "dd/mm".
 */
export const formatListTime = (iso: string): string => {
  const date = new Date(iso);
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.floor((startOfToday.getTime() - date.getTime()) / 86_400_000);

  if (date >= startOfToday) return formatClock(iso);
  if (diffDays < 1) return "Ontem";
  if (diffDays < 7) return WEEKDAYS[date.getDay()];
  return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
};
